export * from "/__w/wiggot-web/wiggot-web/packages/web-components/hooks/useGetTimeSeries.ts"